import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/main.scss";
import PrimeVue from "@/pages/index/plugins/primevue";
import components from "@/pages/form/components";
import { VueReCaptcha } from "vue-recaptcha-v3";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmationService from "primevue/confirmationservice";
import config from "./config";
import FileUpload from "../../components/FileUpload.vue";
import iframeResizerContentWindow from "iframe-resizer";

const app = createApp(App);

app.use(router);
app.use(PrimeVue);
app.use(components);
app.component("ConfirmDialog", ConfirmDialog);
app.component("FileUpload", FileUpload);
app.use(ConfirmationService);
app.use(iframeResizerContentWindow);
app.use(VueReCaptcha, { siteKey: config.recaptchaKey });
app.mount("#app");
